import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import "../style/LegalPage.css";

const legalContent = {
  privacy: {
    title: "Privacy",
    description:
      "Come chiedere informazioni sui dati collegati al tuo account Kyros.",
    sections: [
      {
        heading: "Account e launcher",
        body:
          "L'account serve per accedere, gestire la libreria e collegare i giochi al launcher. Se vuoi informazioni sui dati del tuo account, scrivi al supporto."
      },
      {
        heading: "Richieste sui dati",
        body:
          "Scrivi a support@kyrosgames.com usando l'email del tuo account. Indica se vuoi accesso, rettifica o cancellazione dei dati."
      }
    ]
  },
  cookies: {
    title: "Cookie policy",
    description: "Informazioni sui cookie tecnici e sui servizi esterni usati dal sito.",
    sections: [
      {
        heading: "Cookie tecnici",
        body:
          "Il sito pu\u00f2 usare dati tecnici per far funzionare sessione, preferenze e navigazione."
      },
      {
        heading: "Link esterni",
        body:
          "Discord, YouTube, social e Stripe hanno regole proprie quando li apri fuori dal sito Kyros."
      }
    ]
  },
  terms: {
    title: "Termini e rimborso",
    description: "Informazioni su acquisti, licenze, supporto e richieste di rimborso.",
    sections: [
      {
        heading: "Acquisti",
        body:
          "Gli acquisti dello Store sono collegati all'account Kyros. Prima di comprare, leggi la scheda del gioco e controlla requisiti, stato e supporto."
      },
      {
        heading: "Supporto e rimborso",
        body:
          "Per problemi tecnici, pagamento o rimborso, scrivi al supporto con email dell'account, gioco interessato e ricevuta se disponibile."
      }
    ]
  }
};

export default function LegalPage({ type = "privacy" }) {
  const content = legalContent[type] || legalContent.privacy;

  return (
    <section className="legal-page">
      <SEO
        title={`${content.title} | Kyros Games`}
        description={content.description}
        canonical={`https://kyrosgames.com/${type === "cookies" ? "cookie-policy" : type}`}
      />

      <div className="legal-page__inner">
        <span className="legal-page__eyebrow">Legal</span>
        <h1>{content.title}</h1>
        <p className="legal-page__lead">{content.description}</p>

        <div className="legal-page__sections">
          {content.sections.map(section => (
            <article key={section.heading}>
              <h2>{section.heading}</h2>
              <p>{section.body}</p>
            </article>
          ))}
        </div>

        <div className="legal-page__notice">
          <strong>Supporto:</strong> per richieste su account, pagamenti o rimborso usa l'email del tuo account Kyros
          e conserva il riferimento della transazione.
        </div>

        <Link to="/contact" className="legal-page__cta">
          Contatta il supporto
        </Link>
      </div>
    </section>
  );
}
